import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * DeploymentOptions component - Displays configuration and deployment buttons for AI apps
 * @param {string} appId - The ID of the app to deploy
 * @param {string} position - Position of the component (default: 'bottom')
 * @param {boolean} showLabel - Whether to show the "Deploy As Agent" label
 */
const DeploymentOptions = ({ appId, position = 'bottom', showLabel = true }) => {
  const navigate = useNavigate();

  const handleDeployClick = () => {
    navigate(`/deployment-manager?appType=${appId}`);
  };

  const positionClasses = {
    'top': 'mb-6',
    'bottom': 'mt-6',
    'right': 'ml-4',
    'left': 'mr-4',
    'none': ''
  };

  const marginClass = positionClasses[position] || positionClasses.bottom;

  return (
    <div className={`${marginClass}`}>
      <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
        <div className="flex items-center justify-between">
          {showLabel && (
            <h3 className="text-sm font-medium text-blue-800">Deploy As Agent</h3>
          )}
          <div className="flex space-x-2">
            <button
              onClick={handleDeployClick}
              className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              Deploy
            </button>
            <button
              onClick={handleDeployClick}
              className="inline-flex items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              </svg>
              Configure
            </button>
          </div>
        </div>
        <p className="mt-2 text-xs text-blue-600">
          Deploy this app as an independent agent that can run autonomously on Google Cloud Platform.
        </p>
      </div>
    </div>
  );
};

export default DeploymentOptions; 